<div class="feed-table-wrapper">
<div class="select-head scrollbar" id="scrollcustom" style="display: flex; flex-direction: column">
 <div class="header-wrapper">
  <div>
 <h6>Feeds</h6>
 </div>
<div class="btns" *ngIf="showBackToNewTask">
  <button mat-flat-button (keydown)="backToNewTask()" (click)="backToNewTask()">
    Back to New Task
  </button>
</div>
 </div>
     <!-- Industry selection -->
      <div *ngIf="!industryTypes" class="load">Loading feeds details...</div>
      <div class="table-check" *ngIf="industryTypes">
        <div class="sub-info-preview">
          <div class="info-text">
            <p>Select industries to preview feeds</p>
          </div>
        </div>
      </div>
      <div class="sensor-outer-container">
      <div class="sensor-outer-wrapper">
          <div *ngFor="let industry of industryTypes; let i = index" class="sensor-checkbox">
            <span>
              <mat-checkbox
                [(ngModel)]="industry.selected"
                [checked]="industry.selected"
                (ngModelChange)="industryTypeChange(industry,i); "
              >
                <span
                  style="
                    font-size: 16px;
                    padding-right: 20px;
                    color: #026fc2;
                    font-weight: 300;
                  "
                  >{{ industry.name }}
                  <img *ngIf="industry.description"
                    alt=""
                    [src]="tooltipImagePath"
                    style="margin: 0 0 4px 5px"
                    matTooltip="{{ industry.description }}"
                /></span>
              </mat-checkbox>
            </span>
          </div>
      </div>
      
      </div>
      
  <table *ngIf="dataSource.data.length"
    mat-table
    [dataSource]="dataSource"
    matSort
    class="feed-table">

    <ng-container matColumnDef="feed_name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header style="align-items: center;color: #fff; font-size: 14px; height: 10px;text-align: left; font-weight: 400; cursor: pointer;">
        Feed name
      </th>
      <td mat-cell *matCellDef="let row">
        {{ row.feedName }}
      </td>
    </ng-container>

    <ng-container matColumnDef="description">
      <th mat-header-cell *matHeaderCellDef mat-sort-header style="align-items: center;color: #fff; font-size: 14px; height: 10px;text-align: left; font-weight: 400; cursor: pointer;">
        Description
      </th>
      <td mat-cell *matCellDef="let row"  class="description-col">
        {{ row.description }}
      </td>
    </ng-container>

    <ng-container matColumnDef="f1Score">
      <th mat-header-cell *matHeaderCellDef mat-sort-header style="align-items: center;color: #fff; font-size: 14px; height: 10px;text-align: left; font-weight: 400; cursor: pointer;">
        F1 Score
      </th>
      <td mat-cell *matCellDef="let row"  class="align-item-center">
        {{ row.f1Score }}
      </td>
    </ng-container>

    <ng-container matColumnDef="cost">
      <th mat-header-cell *matHeaderCellDef mat-sort-header style="align-items: center;color: #fff; font-size: 14px; height: 10px;text-align: left; font-weight: 400; cursor: pointer;">
        Cost
      </th>
      <td mat-cell *matCellDef="let row"  class="align-item-center">
        <span *ngIf="!pointUser">
          {{ convertCostToPoints(row.cost, true, row)}}
        </span>
        <span *ngIf="pointUser">
          {{ convertCostToPoints(row.cost, true, row)}}
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="location">
      <th mat-header-cell *matHeaderCellDef mat-sort-header style="align-items: center;color: #fff; font-size: 14px; height: 10px;text-align: left; font-weight: 400; cursor: pointer;">
        Location (land/water/both)
      </th>
      <td mat-cell *matCellDef="let row" class="align-item-center">
        {{ row.location }}
      </td>
    </ng-container>

    <ng-container matColumnDef="supported_sensor_types">
      <th mat-header-cell *matHeaderCellDef mat-sort-header style="align-items: center;color: #fff; font-size: 14px; height: 10px;text-align: left; font-weight: 400; cursor: pointer;">
        Supported sensor type
      </th>
      <td mat-cell *matCellDef="let row" class="align-item-center">
        {{ row.sensorsType }}
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

  </table>
    <app-notask *ngIf="selectedIndustryList.length != 0 && dataSource.data.length === 0" [feeds]=true></app-notask>

 </div>
</div>
